import { render, staticRenderFns } from "./deliverysite.vue?vue&type=template&id=10b9775f&scoped=true&"
import script from "./deliverysite.vue?vue&type=script&lang=js&"
export * from "./deliverysite.vue?vue&type=script&lang=js&"
import style0 from "./deliverysite.vue?vue&type=style&index=0&id=10b9775f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b9775f",
  null
  
)

export default component.exports